import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import * as $ from 'jquery';
import {MerchantListComponent} from './merchant-list.component';
import {NgForm} from '@angular/forms';
import * as myGlobals from './../global';
import {MerchantsService} from './merchants-service';
import {IResultados} from './IMerchant';
import {HttpErrorValidator} from '../services/http-error-validator';

@Component({
  selector: 'pm-modal-search-merchant',
  templateUrl: './modal-search-merchant.component.html',
  styleUrls: ['./modal-search-merchant.component.sass']
})
export class ModalSearchMerchantComponent implements OnInit {
  estadosDeComercio: IResultados[] = [];
  estadosDeComercioDetail: IResultados[] = [];

  constructor(private parent: MerchantListComponent, public serviceComercios: MerchantsService,
              private httpErrorValidator: HttpErrorValidator) {
  }

  ngOnInit() {
    this.getEstadosComercio();
    this.getDetalleEstadosComercio();
    this.resetForm();
  }

  cancelModal(): void {
    this.parent.showComercios = true;
    this.parent.showModalComercios = false;
  }

  getEstadosComercio(): void {
    this.serviceComercios.getSellerstatus().subscribe(response => {
      this.estadosDeComercio = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getDetalleEstadosComercio(): void {
    this.serviceComercios.getSellerstatusDetail().subscribe(response => {
      this.estadosDeComercioDetail = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  buscar(form: NgForm): void {
    this.serviceComercios.getComercioFiltro().subscribe(comercios => {
      this.parent.resultadosBusqueda = comercios;
      this.parent.showModalComercios = false;
      this.parent.showSearchMerchant = true;
    });
  }

  resetForm(form?: NgForm): void {
    if (form != null) {
      form.resetForm();
    }
    this.serviceComercios.busqueda = {
      seDetailStatusCode: '',
      sellerId: '',
      sellerLegalName: '',
      sellerStatus: '',
    };
  }
}
